<script setup lang="ts">
import Forbidden403 from './403.vue'
import Forbidden402 from './402.vue'

import type { PermissionsError } from '@/composables/error'

const props = defineProps<{
  error: PermissionsError
}>()

const errorComponents = [
  {
    component: Forbidden403,
    statusCode: 403
  },
  {
    component: Forbidden402,
    statusCode: 402
  }
]

const errorComponent = computed(() => errorComponents.find((error) => error.statusCode === props.error.statusCode))
</script>

<template>
  <component :is="errorComponent.component" v-if="errorComponent" :module="error.module"></component>
</template>
